import {withFormik} from "formik";
import {Input, Button} from "../../commons";
import Validations from "../FormWarehouse/Validations";
import {t} from "i18next";
import React from "react";

interface FulfillmentFormFields {
    token: string
    login: string
    password: string
    address: string
    updateFrequency: string
}

interface FulfillmentFormProps {
    values: FulfillmentFormFields,
    touched: any,
    errors: any,
    handleChange: any,
    handleBlur: any,
    handleSubmit: any,
}

const initialFields: FulfillmentFormFields = {
    token: '',
    login: '',
    password: '',
    address: '',
    updateFrequency: '',
}

const InnerFormFulfillment: React.FC<FulfillmentFormProps> = ({
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit
}) => {
    const customInputClassName = 'border-[#E2E8F0] mb-4 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'
    return (
        <form onSubmit={handleSubmit} className="w-full">
            <Input
                id="tokenFulfillment"
                name="tokenFulfillment"
                placeholder={t<string>("Токен", {ns: "messages"})}
                label={t<string>("Токен", {ns: "messages"})}
                value={values.token}
                changeHandler={handleChange}
                blurHandler={handleBlur}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
            />
            <Input
                id="loginFulfillment"
                name="loginFulfillment"
                placeholder={t<string>("Логин", {ns: "messages"})}
                label={t<string>("Логин", {ns: "messages"})}
                value={values.login}
                changeHandler={handleChange}
                blurHandler={handleBlur}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
            />
            <Input
                id="passwordFulfillment"
                name="passwordFulfillment"
                type="password"
                placeholder={t<string>("Пароль", {ns: "messages"})}
                label={t<string>("Пароль", {ns: "messages"})}
                value={values.password}
                changeHandler={handleChange}
                blurHandler={handleBlur}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
            />
            <Input
                id="addressFulfillment"
                name="addressFulfillment"
                placeholder={t<string>("Адрес", {ns: "messages"})}
                label={t<string>("Адрес", {ns: "messages"})}
                value={values.address}
                changeHandler={handleChange}
                blurHandler={handleBlur}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
            />
            <Input
                id="updateFrequencyddressFulfillment"
                name="updateFrequencyFulfillment"
                placeholder={t<string>("Частота обновления", {ns: "messages"})}
                label={t<string>("Частота обновления", {ns: "messages"})}
                value={values.updateFrequency}
                changeHandler={handleChange}
                blurHandler={handleBlur}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
            />
            <div className="w-full flex justify-end">
                <Button
                    type="submit"
                    appearance="primary"
                    // loading={isSubmitting}
                >
                    {t<string>("Подключиться", {ns: "messages"})}
                </Button>
            </div>

        </form>
    )
}

const FormFulfillment = withFormik({
    mapPropsToValues: () => (initialFields),

    // Custom sync validation
    validate: values => {
        const errors = {};

        const validation = Validations();

        //@ts-ignore
        Object.keys(values).forEach((key) => validation[key] && validation[key](errors, values[key]))

        return errors;
    },

    handleSubmit: (values, { setSubmitting }) => {
        setTimeout(() => {
            alert(JSON.stringify(values, null, 2));
            setSubmitting(false);
        }, 1000);
    },

    displayName: 'FulfillmentForm',
})(InnerFormFulfillment)

export default FormFulfillment;